// extracted by mini-css-extract-plugin
module.exports = {"card":"card--1rGFj","card_img":"card_img--3C4fT"};